import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loading from './layouts/Loading';
import UsuarioSesion from './components/UsuarioSesion';

/**
 * App React
 */
function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const title = useSelector((state) => state.title.value);

  // location change use effect
  useEffect(() => {
    // redireccion a la pagina de inicio
    if (location.pathname == '/') {
      navigate('/site');
    }

    // hide menu mobile
    if (document.querySelector('.main-nav')) {
      document.querySelector('.main-nav').classList.remove('show');
    }
  }, [location]);

  // window title use effect
  useEffect(() => {
    if (title.trim()) {
      window.document.title = title + ' | Zeta Banco';
    } else {
      window.document.title = 'Zeta Banco';
    }
  }, [title]);

  return (
    <div>
      <UsuarioSesion />
      <Outlet />
      <ToastContainer pauseOnFocusLoss={false} />
      <Loading />
    </div>
  );
}

export default App;
